<label
  class="chapter-taiga-dropzone-content"
  [class.is-disabled]="loading"
  [class.is-dragged]="isDragged"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <div class="chapter-taiga-dropzone-icon">⬆</div>
  <span class="chapter-taiga-dropzone-button">Choose files to Upload</span>
  <span class="chapter-taiga-dropzone-hint">
    {{ isDragged ? 'Drop files to upload' : 'or drag and drop them here' }}
  </span>
  <input
    type="file"
    class="chapter-taiga-dropzone-input"
    [accept]="accept"
    [multiple]="true"
    [disabled]="loading"
    (change)="onInputChange($event)"
  />
</label>
